<template>
  <div>
    <!-- 查看详情弹框开始 -->
    <el-dialog
      :close-on-click-modal="false"
      title="订单信息"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="1600px"
      center
      top="5vh"
    >
      <el-divider></el-divider>
      <div class="infoForm">
        <div class="form_input">
          <div class="input_box">
            <span>用户姓名：</span>
            <el-input v-model="form.name" disabled></el-input>
          </div>
          <div class="input_box">
            <span>联系电话：</span>
            <el-input v-model="form.phone" disabled></el-input>
          </div>
          <div class="input_box">
            <span>第三方编号：</span>
            <el-input v-model="form.id" disabled></el-input>
          </div>
          <div class="notes">
            <span>备注：</span>
            <el-input v-model="form.OrderRemarks" disabled></el-input>
          </div>
        </div>
        <div class="orderNumbers">
          <div>订单编号：{{ form.OrderNumber }}</div>
          <div>下单时间：{{ form.CreateTime }}</div>
          <div>代理价：{{ form.product[0].Price }}</div>
          <div>合计：{{ form.product[0].ActPrice }}</div>
          <div v-if="form.idcard!=''">
            身份证： {{form.idcard}}
          </div>
          <div  v-if="form.access_flag!=''">
            身份证过门禁：{{form.access_flag=='1'?'是':'否'}}
          </div>
        </div>
        <div style="margin-top: 1.8rem">
          <el-table
            :data="form.product"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
            :span-method="tableNumAndPSpanMethod"
          >
            <el-table-column prop="CreateTime" label="产品名称" width="200">
              <template slot-scope="scope">
                {{ scope.row.OrderAll.productname }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="OrderNumber" label="代理价">
                <template slot-scope="scope">
                    {{ scope.row.OrderAll.agentprice }}
                </template>
              </el-table-column>
              <el-table-column  label="合计">
                <template slot-scope="scope">
                    {{ scope.row.OrderAll.agentprice * scope.row.Count }}
                </template>
              </el-table-column> -->
            <el-table-column label="消费日期" width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.OrderAll.type == '0'">
                  {{ scope.row.OrderAll.consumebegindate }}-{{
                    scope.row.OrderAll.consumeenddate
                  }}
                </div>
                <div v-else>
                  {{ scope.row.playdate }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="可用星期" width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.OrderAll.type == '0'">
                  {{ scope.row.OrderAll.arr }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="可用时间">
              <template slot-scope="scope">
                {{ scope.row.OrderAll.usebegintime }}-{{
                  scope.row.OrderAll.useendtime
                }}
              </template>
            </el-table-column>
            <el-table-column prop="CountUse" label="已使用"></el-table-column>
            <el-table-column label="未使用">
              <template slot-scope="scope">
                {{
                  scope.row.Count - scope.row.CountUse - scope.row.CancleCount
                }}
              </template>
            </el-table-column>
            <el-table-column prop="CancleCount" label="已退款">
            </el-table-column>
            <!-- <el-table-column  label="可退数量">
                <template slot-scope="scope">
                    {{ scope.row.Count-scope.row.CountUse - scope.row.CancleCount }}
                </template>
              </el-table-column> -->
            <el-table-column label="是否可退">
              <template slot-scope="scope">
                {{ scope.row.OrderAll.returnflag == "0" ? "可退" : "不可退" }}
              </template>
            </el-table-column>
            <el-table-column label="套票数量" v-if="form.ordertype == 2">
              <template slot-scope="scope">
                {{ form.Count }}
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.counts"
                  type="number"
                  :min="0"
                  @input="handleCountInput(scope.$index, scope.row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <!-- {{scope.row.Count}} {{scope.row.CountUse}} {{scope.row.CancleCount}} -->
                <el-button
                  type="text"
                  @click="wirteFn(scope.row)"
                  v-if="
                    (scope.row.Count -
                      scope.row.CountUse -
                      scope.row.CancleCount !=
                      0 && !GetChannelFlow && !_type) || _type
                  "
                  >退票</el-button
                >
                <el-button
                  type="text"
                  @click="chexiao(scope.row)"
                  v-if="scope.row.CancleCount > 0 && !GetChannelFlow && !_type"
                  >撤销退款</el-button
                >
                <el-button
                  type="text"
                  @click="revoke(scope.row)"
                  v-if="scope.row.CountUse > 0 && !_type"
                  >撤销核销</el-button
                >
                <!-- <el-button
                  type="text"
                  @click="RefundClick(scope.row)"
                  v-if="scope.row.CountUse > 0"
                  >强制退票</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom_button"></div>
      </div>
    </el-dialog>
    <!-- 查看详情弹框结束 -->
  </div>
</template>

<script>
import {
  getScenicOrderInfo,
  ScenicRefund,
  RevocationRefund,
  fulfilmentCancel,
  ScenicForceRefund,
} from "@/request/scenic.js";
import { Message, MessageBox } from "element-ui";
export default {
  props: ["row", "disid"],
  data() {
    return {
      infoDialogVisible: false, // 产品详情
      form: {
        name: "",
        phone: "",
        id: "",
        msk: "--",
        OrderNumber: "",
        CreateTime: "",
        productname: "",
        product: [],
        OrderCode: "",
        OrderID: "",
        nums: 0,
        idcard:'',
        access_flag:''
      },
      GetChannelFlow: false,
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("ScenicId") == "131") {
      this.GetChannelFlow = true;
    } else {
      this.GetChannelFlow = false;
    }
    this.getList();
  },
  computed: {
    _type(){
      if(this.form.product.length > 0 && this.form.product[0].producttype == "2"){
        return true
      }
      return false
    }
  },
  methods: {
    handleCountInput(index, row) {
      // 确保输入值不能为负数
      if (row.counts < 0 || row.counts === null || row.counts === undefined) {
        row.counts = 0;
      }
      // 如果是字符串，转换为数字
      if (typeof row.counts === 'string') {
        const num = parseFloat(row.counts);
        if (isNaN(num) || num < 0) {
          row.counts = 0;
        } else {
          row.counts = num;
        }
      }
      this.onExchange(index);
    },
    onExchange(index) {
      this.$forceUpdate();
    },
    RefundClick(row) {
      if (row.counts == "" || row.counts == 0) {
        Message.error("请输入强制退票数量");
        return false;
      }
      if (row.counts > row.CountUse) {
        Message.error("强制退票数量不能大于已使用数量");
        return false;
      }
      MessageBox(`是否强制退票?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            ordernumber: this.form.OrderNumber,
            orderdeatild: row.OrderDetailID,
            DistributorID: this.disid,
            OrderID: this.form.OrderID,
            ordernum: row.counts,
            token: window.sessionStorage.getItem("Token"),
          };
          ScenicForceRefund(data).then((res) => {
            if (res.data.rcode == "200") {
              Message.success("强制退票成功");
              this.getList();
            } else {
              Message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    //撤销核销
    revoke(row) {
      if (row.counts == "" || row.counts == 0) {
        Message.error("请输入撤销核销数量");
        return false;
      }
      MessageBox(
        `撤销核销后只同步雪务通订单、不同步第三方订单 强制核销全部产品 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let data = {
            OrderID: this.form.OrderID,
            OrderDetailID: row.OrderDetailID,
            ordernum: row.counts,
            token: window.sessionStorage.getItem("Token"),
          };
          fulfilmentCancel(data).then((res) => {
            if (res.data.rcode == "200") {
              Message.success("撤销核销成功");
              this.getList();
            } else {
              Message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },

    chexiao(row) {
      if (row.counts == "" || row.counts == 0) {
        Message.error("请输入撤销退款数量");
        return false;
      }
      MessageBox(
        `撤销退款后只同步雪务通订单、不同步第三方订单 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let data = {
            OrderID: row.OrderID,
            OrderDetailID: row.OrderDetailID,
            ordernum: row.counts,
            token: window.sessionStorage.getItem("Token"),
          };
          RevocationRefund(data).then((res) => {
            if (res.data.rcode == 200) {
              Message.success("撤销退款");
              this.getList();
            } else {
              Message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    wirteFn(row) {
      if (row.counts == "" || row.counts == 0) {
        Message.error("请输入退款数量");
        return false;
      }

      if (this._type){
        if (Number(row.counts) > Number(this.form.Count)) {
          Message.error("退款数量不能大于套票数量");
          return false;
        }
      }

      MessageBox(`退款后只同步雪务通订单、不同步第三方订单 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            ordernumber: this.form.OrderNumber,
            orderdeatild: row.OrderDetailID,
            DistributorID: this.row.DistributorID,
            ordernum: row.counts,
            token: window.sessionStorage.getItem("Token"),
          };
          //套票退款参数更改
          if(this.form.product.length > 0 && this.form.product[0].producttype == "2"){
            let product = this.form.product
            let OrderDetailIDs = product.map(e => e.OrderDetailID).toString()
            data.orderdeatild = OrderDetailIDs
          }
          ScenicRefund(data).then((res) => {
            if (res.data.rcode == 200) {
              Message.success("成功退款");
              this.getList();
            } else {
              Message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    getList() {
      let data = {
        order_id: this.row.OrderID,
        token: window.sessionStorage.getItem("Token"),
      };
      getScenicOrderInfo(data).then((res) => {
        if (res.data.rcode == 200) {
          res.data.result.order_detail.map((item) => {
            item.counts = 0;
          });
          this.form = {
            name: res.data.result.consumer,
            phone: res.data.result.Mobile,
            id: res.data.result.OnlyCode,
            msk: "",
            OrderNumber: res.data.result.OrderNumber,
            CreateTime: res.data.result.order_detail[0].CreateTime,
            product: res.data.result.order_detail,
            Mobile: res.data.result.Mobile,
            OrderCode: res.data.result.OrderCode,
            OrderID: res.data.result.OrderID,
            idcard: res.data.result.idcard,
            access_flag: res.data.result.access_flag,
            OrderRemarks:res.data.result.OrderRemarks,
            Count: res.data.result.Count,
            ordertype: res.data.result.ordertype
          };
          this.form.nums = 0;
          this.form.product.map((item) => {
            item.Ktnum = item.Count - item.CountUse - item.CancleCount;
            this.form.nums += item.Count - item.CountUse - item.CancleCount;
            item.flags = item.OrderAll.numberflag == "1" ? "是" : "否";
            let arr = "";
            if (item.OrderAll.weeks) {
              JSON.parse(item.OrderAll.weeks).map((itm) => {
                switch (itm) {
                  case "1":
                    arr += "一" + "、";
                    break;
                  case "2":
                    arr += "二" + "、";
                    break;
                  case "3":
                    arr += "三" + "、";
                    break;
                  case "4":
                    arr += "四" + "、";
                    break;
                  case "5":
                    arr += "五" + "、";
                    break;
                  case "6":
                    arr += "六" + "、";
                    break;
                  case "7":
                    arr += "日";
                    break;
                  default:
                    break;
                }
              });
              item.OrderAll.arr = arr;
            }
          });
        }
      });
    },
    // 查看详情
    seeInfo() {
      this.infoDialogVisible = true;
    },
    // 查看详情
    infoHandleClose() {
      this.infoDialogVisible = false;
      this.$emit("orderClose");
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex,
      });
    },

    tableNumAndPSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.form.product.length > 0 && this.form.product[0].producttype == "2") {
        const dataLength = this.form.product.length;

        // 合并"套票数量"列
        if (columnIndex === 8) {
          return rowIndex === 0 ? [dataLength, 1] : [0, 0];
        }
        
        // 合并"数量"列
        if (columnIndex === 9) {
          return rowIndex === 0 ? [dataLength, 1] : [0, 0];
        }
        
        // 合并"操作"列  
        if (columnIndex === 10) {
          return rowIndex === 0 ? [dataLength, 1] : [0, 0];
        }
      }
      
      return [1, 1];
    }
  },
};
</script>

<style lang='less' scoped>
.infoForm {
  box-sizing: border-box;
  .form_input {
    width: 100%;
    display: flex;
    align-items: center;
    .input_box {
      display: flex;
      align-items: center;
      margin-right: 1.9rem;
      /deep/.el-input {
        width: 22.2rem;
      }
      span {
        color: #666;
        text-align: right;
        font-family: OPPOSans;
        font-size: 1.4rem;
        display: block;
        width: 8.4rem;
      }
    }
    .notes {
      flex: 1;
      display: flex;
      align-items: center;
      /deep/.el-input {
        width: 90%;
      }
      span {
        color: #666;
        text-align: right;
        font-family: OPPOSans;
        font-size: 1.4rem;
        display: block;
        width: 5rem;
      }
    }
  }
  .orderNumbers {
    display: flex;
    align-items: center;
    margin-top: 3rem;
    div {
      color: #666;
      font-family: OPPOSans;
      font-size: 1.4rem;
      font-style: normal;
      font-weight: 400;
      margin-right: 2rem;
    }
  }
}
.bottom_button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  div {
    padding: 0 2rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #246deb;
    color: #fff;
    color: #fff;
    text-align: center;
    font-size: 1.4rem;
    margin-right: 2rem;
    cursor: pointer;
  }
}
/deep/.el-input__inner {
  background: #fff !important;
  color: #666 !important;
}
</style>